
import React from "react";

const LessonPrompt = () => {
  return (
    <div className="mb-8">
      <div className="p-4 border rounded bg-gray-50 text-center">
        <p className="text-gray-600">Please select a lesson from the menu to start learning.</p>
      </div>
    </div>
  );
};

export default LessonPrompt;
